// extracted by mini-css-extract-plugin
module.exports = {"price":"dd31006766--price--WYEqv"};